import React, { createContext, useContext, useState, useEffect } from "react";
import { request, clearSession } from "../api/http";
const Context = createContext();
export const useSession = () => useContext(Context);
export default function SessionProvider({ children }) {
  const [session, setSession] = useState(null),
    [loading, setLoading] = useState(true),
    [error, setError] = useState("");
  const logout = () => {
    clearSession();
    setSession(null);
  };
  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const s = await request("comercial-app/capabilities");
      localStorage.setItem("permissions", JSON.stringify(s.permissions || []));
      localStorage.setItem("user", JSON.stringify(s.usuario));
      localStorage.setItem("empresa", JSON.stringify(s.empresa));
      setSession(s);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("authToken")) load();
    else setLoading(false);
    window.addEventListener("session-expired", logout);
    return () => window.removeEventListener("session-expired", logout);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    let pending = false;
    const renew = async () => {
      if (pending || !localStorage.getItem("authToken")) return;
      pending = true;
      try {
        // The authenticated endpoint renews JWT through the ERP middleware.
        await request("comercial-app/capabilities");
      } catch (_) {
        // HTTP handles expired credentials; temporary network errors keep the form.
      } finally {
        pending = false;
      }
    };
    const timer = window.setInterval(renew, 5 * 60 * 1000);
    window.addEventListener("focus", renew);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", renew);
    };
  }, []);
  const login = async (credentials) => {
    const d = await request("login", { method: "POST", body: credentials });
    localStorage.setItem("authToken", d.token);
    await load();
  };
  return (
    <Context.Provider
      value={{ session, loading, error, login, logout, reload: load }}
    >
      {children}
    </Context.Provider>
  );
}
